module.exports = __webpack_public_path__ + "media/ab-homepage/missing-form-b80ff2a5.png";